// import { Navigate, Outlet, useLocation } from 'react-router-dom'
// import Layout from '../layout'

// const ProtectedRoute = ({ children, ...rest }) => {
// 	const location = useLocation()
// 	const userPermissions = localStorage.getItem('permissions')?.split(',') || []
// 	const userData = JSON.parse(localStorage.getItem('user') || '{}')
// 	const token = localStorage.getItem('token')
// 	const isAdmin = userData?.isAdmin === true
// 	const hasPermissions = userPermissions.length > 0
// 	const hasAnyAccess =
// 		!!userData?.adminOfHubs || !!userData?.adminOfSanstha?.length || !!userData?.hub

// 	if (!token && !isAdmin) {
// 		return <Navigate to="/" />
// 	}
// 	const currentPath = location.pathname.substring(1)

// 	if (!isAdmin && !hasPermissions && !hasAnyAccess) {
// 		return <Navigate to="/" />
// 	}

// 	if (isAdmin) {
// 		return (
// 			<Layout>
// 				<Outlet />
// 			</Layout>
// 		)
// 	}
// 	if (userPermissions && userPermissions.length > 0 && currentPath) {
// 		// if (currentPath === "dashboard") {
// 		//   return (
// 		//     <Layout>
// 		//       <Outlet />
// 		//     </Layout>
// 		//   );
// 		// }
// 		// Check if the current path starts with any of the user's permissions
// 		if (userPermissions.some(permission => currentPath.startsWith(permission))) {
// 			return (
// 				<Layout>
// 					<Outlet />
// 				</Layout>
// 			)
// 		}
// 		return <Navigate to={`/${userPermissions[0]}`} />
// 	}
// 	return <Navigate to="/" />
// }

// export default ProtectedRoute

import { Navigate, Outlet, useLocation } from 'react-router-dom'
import Layout from '../layout'
import { getRoutePermissions } from '../utils/permissionHelper'

const ProtectedRoute = () => {
	const location = useLocation()
	const token = localStorage.getItem('token')
	const userPermissions = localStorage.getItem('permissions')?.split(',') || []
	const userData = JSON.parse(localStorage.getItem('user') || '{}')
	const isAdmin = userData?.isAdmin === true

	if (!token) {
		return <Navigate to="/" />
	}

	if (isAdmin) {
		return (
			<Layout>
				<Outlet />
			</Layout>
		)
	}

	const routePermissions = getRoutePermissions(location.pathname)

	if (routePermissions.length > 0) {
		const hasAccess = routePermissions.some(permission => userPermissions.includes(permission))

		if (!hasAccess) {
			return <Navigate to={`/${userPermissions[0]}`} />
		}
	}

	return (
		<Layout>
			<Outlet />
		</Layout>
	)
}

export default ProtectedRoute
